import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  tone?: "light" | "dark";
};

export default function Breadcrumb({ items, tone = "light" }: BreadcrumbProps) {
  const base = tone === "light" ? "text-foreground-500" : "text-background-200";
  const active = tone === "light" ? "text-foreground-900" : "text-background-50";

  return (
    <nav aria-label="面包屑" className={`flex flex-wrap items-center gap-1.5 text-xs ${base}`}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="transition-colors hover:text-accent-500">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? active : undefined}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-[12px] opacity-60" />}
          </span>
        );
      })}
    </nav>
  );
}